import './styles.css'

function Header() {
    return (
        <header className='header-app'>
            App Consulta Clima
        </header>
    )
}

export default Header